module.exports = __webpack_public_path__ + "fonts/IntelOneMono-Regular.woff2";